import React from 'react';
import { useLocation } from 'react-router-dom';
import { useGeoLocation } from '../../hooks/useGeoLocation';
import { useGeoConfig } from '../../context/GeoConfigContext';
import RegionBanner from './RegionBanner';
import GeoBlockScreen from './GeoBlockScreen';
import ComingSoonBanner from './ComingSoonBanner';
import ComingSoonScreen from './ComingSoonScreen';
import UnsupportedBanner from './UnsupportedBanner';
import UnsupportedScreen from './UnsupportedScreen';

const GeoGuard: React.FC = () => {
  const { pathname } = useLocation();
  const { countryCode, countryName, isLoading: geoLoading } = useGeoLocation();
  const { config, isLoading: configLoading } = useGeoConfig();

  // Wait for both config fetch and geo detection to complete
  if (geoLoading || configLoading) return null;

  // Nothing to show if banner is disabled in config
  if (!config.showBanner) return null;

  // If geo is not detected, we let them through until detection works
  if (!countryCode) return null;

  const code = countryCode.toUpperCase();
  
  // 1. The Allow Case (Strict Allowlist)
  if (config.availableCountries.includes(code)) {
    return null; // Full unhindered access
  }

  // Check if this route requires a hard block (e.g. KYC)
  const isHardBlockRoute = config.hardBlockRoutes.some((prefix) =>
    pathname.startsWith(prefix)
  );

  // 2. The Blocked Case (Restricted Regions)
  if (config.blockedCountries.includes(code)) {
    return <GeoBlockScreen countryName={countryName} />;
  }

  // 3. The Coming Soon Case
  if (config.comingSoonCountries.includes(code)) {
    if (isHardBlockRoute) {
      return <ComingSoonScreen countryName={countryName} />;
    }
    return <ComingSoonBanner countryName={countryName} />;
  }

  // 4. The Default Unsupported Case
  if (isHardBlockRoute) {
    return <UnsupportedScreen countryName={countryName} />;
  }
  return <UnsupportedBanner countryName={countryName} />;
};

export default GeoGuard;
